import { storefrontAiAr } from './storefront.ai.ar';
import { storefrontNeedsAr } from './storefront.needs.ar';
/** Vitrin arayüz metinleri (ar). Vitrinin istemci paketi yalnızca bunu ve ortak/hata metinlerini yükler (F7-17). */
export const storefrontAr = {
  google: {
    or: 'أو',
    continue: 'المتابعة باستخدام Google',
    signUpTitle: 'التسجيل عبر Google',
    newAccount: 'سيُنشأ حساب جديد بحساب Google ‏{{email}}.',
    name: 'الاسم: {{name}}',
    noPassword: 'يُنشأ حسابك بلا كلمة مرور؛ ويمكنك تعيين واحدة متى شئت من حسابي ← الحسابات المرتبطة.',
    createAccount: 'أنشئ الحساب',
    linkedTitle: 'الحسابات المرتبطة',
    linked: 'حساب Google: ‏{{email}}',
    setPasswordFirst: 'عيّن كلمة مرور قبل إزالة ربط Google؛ وإلا فلن تتمكن من الدخول.',
    newPassword: 'كلمة مرور جديدة',
    setPassword: 'عيّن كلمة المرور',
    passwordSet: 'تم تعيين كلمة المرور.',
    unlink: 'أزل ربط Google',
    unlinkConfirm: 'إزالة ربط Google؟ ستدخل بعدها ببريدك وكلمة المرور.',
    unlinked: 'أُزيل ربط Google.',
    reauth: 'سجّل الدخول باستخدام Google مرة أخرى',
  },
  ai: storefrontAiAr,
  needsFinder: storefrontNeedsAr,
  brands: 'العلامات التجارية',
  suggest: {
    label: 'اقتراحات البحث',
    groups: {
      products: 'المنتجات',
      categories: 'الفئات',
      brands: 'العلامات التجارية',
      all: 'جميع النتائج',
    },
    all: 'جميع نتائج "{{q}}" ({{count}})',
    status: '{{count}} اقتراحات. استخدم السهم السفلي للاختيار.',
    none: 'لا توجد اقتراحات. اضغط Enter للبحث.',
  },
  quick: {
    view: 'عرض سريع: {{title}}',
    viewShort: 'عرض سريع',
    add: 'إضافة إلى السلة: {{title}}',
    addShort: 'إضافة إلى السلة',
    title: 'عرض سريع',
    close: 'إغلاق',
    details: 'الانتقال إلى صفحة المنتج',
    loading: 'جارٍ التحميل…',
    failed: 'تعذّر تحميل المنتج. افتح صفحة المنتج.',
  },
  filters: {
    open: 'عوامل التصفية',
    title: 'عوامل التصفية',
    close: 'إغلاق',
    form: 'عوامل تصفية المنتجات',
    brand: 'العلامة التجارية',
    price: 'السعر ({{currency}})',
    priceMin: 'الحد الأدنى',
    priceMax: 'الحد الأقصى',
    stock: 'التوفر',
    inStockOnly: 'المتوفر فقط',
    discount: 'الخصم',
    discountedOnly: 'المنتجات المخفّضة',
    active: 'عوامل التصفية المحددة',
    remove: 'إزالة عامل التصفية: {{name}}',
    clearAll: 'مسح الكل',
    below: 'أقل من {{max}}',
    above: '{{min}} فأكثر',
    range: '{{min}}–{{max}}',
    priceChip: 'السعر: {{range}}',
    option: '{{label}} ({{count}})',
  },
  preparingTitle: 'متجرنا الجديد قادم قريبًا',
  preparingLead: 'هذا الموقع قيد الإنشاء. سنكون هنا عند فتح باب الطلبات.',
  brandsLabel: 'علاماتنا التجارية',
  contactLater: 'ستُنشر بيانات الاتصال والبائع على هذه الصفحة قبل الإطلاق.',
  unknownDomainTitle: 'لا يوجد متجر على هذا العنوان بعد',
  unknownDomainLead:
    'يصل النطاق إلى الخادم لكنه غير مرتبط بأي متجر. افتح المتاجر في لوحة التحكم وأضف هذا النطاق.',
  unavailableTitle: 'المتجر لا يستجيب حاليًا',
  unavailableLead: 'قد تكون هناك صيانة قصيرة أو مشكلة في الاتصال. يُرجى المحاولة مرة أخرى بعد بضع دقائق.',
  notFoundTitle: 'الصفحة غير موجودة',
  notFoundLead: 'ربما تغيّر العنوان أو أُزيلت الصفحة. ابحث في منتجاتنا أو تابع عبر الروابط أدناه.',
  notFoundSearch: 'البحث في المنتجات',
  notFoundHome: 'الصفحة الرئيسية',
  goneTitle: 'أُزيلت هذه الصفحة',
  goneLead: 'أُزيلت الصفحة التي تبحث عنها نهائيًا.',
  maintenanceTitle: 'نجري صيانة قصيرة',
  maintenanceLead: 'سيُعاد فتح المتجر قريبًا.',
  acceptMembership: 'قرأت شروط العضوية وإشعار الخصوصية وأوافق عليهما.',
  acceptSalesTerms: 'قرأت نموذج المعلومات المسبقة وعقد البيع عن بُعد وأوافق عليهما.',
  activateTitle: 'فعّل حسابك',
  activateLead: 'مرحبًا {{name}}، أنشأ المتجر حسابك. عيّن كلمة المرور الخاصة بك.',
  resetLead: 'مرحبًا {{name}}، عيّن كلمة المرور الجديدة.',
  addToCart: 'إضافة إلى السلة',
  buyNow: 'اشترِ الآن',
  added: 'تمت الإضافة إلى السلة.',
  all: 'الكل',
  allProducts: 'جميع المنتجات',
  pageTitleNumbered: '{{title}} – الصفحة {{page}}',
  allSpecies: 'الكل',
  applicationPending: 'طلب انضمامك كموزّع قيد المراجعة.',
  applicationReceived:
    'تم استلام طلبك. سنرسل إليك النتيجة بالبريد الإلكتروني؛ ويمكنك أيضًا متابعته من صفحة حسابي.',
  applicationRejected: 'لم تتم الموافقة على طلبك السابق.',
  apply: 'تطبيق',
  applyCoupon: 'تطبيق',
  applyDealer: 'طلب الانضمام كموزّع',
  applyLead:
    'إذا كنت عيادة بيطرية أو متجرًا للحيوانات الأليفة أو صيدلية، يمكنك التقدّم كموزّع. بعد الموافقة سترى أسعار الموزّعين عند تسجيل الدخول.',
  applySignInFirst: 'سجّل الدخول أو أنشئ حسابًا لتقديم الطلب.',
  awaitingPaymentNote: 'طلبك بانتظار الدفع.',
  breadcrumb: 'مسار التنقل',
  cart: 'سلة التسوق',
  cartEmpty: 'سلة التسوق فارغة.',
  cartWithCount: 'سلة التسوق، {{count}} منتجات',
  speciesProperty: 'النوع المستهدف',
  speciesNames: {
    cat: 'قطة',
    dog: 'كلب',
    bird: 'طائر',
    rodent: 'قارض صغير',
    rabbit: 'أرنب',
    reptile: 'الزواحف والسلاحف',
    exotic: 'حيوانات غريبة أخرى',
  },
  categories: 'الفئات',
  changePassword: 'تغيير كلمة المرور',
  checkout: 'إتمام الطلب',
  chooseOption: 'اختر خيارًا.',
  consents: 'الرسائل التسويقية',
  privacy: {
    title: 'بياناتي الشخصية',
    lead: 'يمكنك ممارسة حقوقك المتعلقة ببياناتك الشخصية (المادة 11 من KVKK) من هنا. التفاصيل:',
    noticeLink: 'إشعار الخصوصية',
    exportTitle: 'تنزيل بياناتي',
    exportLead: 'تُنزَّل فورًا نسخة من حسابك وعناوينك وطلباتك وموافقاتك وسجلاتك الأخرى كملف JSON.',
    password: 'كلمة المرور',
    export: 'تنزيل بياناتي',
    exported: 'تم تنزيل بياناتك.',
    erasureTitle: 'حذف حسابي',
    erasureLead:
      'يُبتّ في طلب الحذف خلال 30 يومًا ويُرسل إليك إشعار بالبريد الإلكتروني. يُغلق حسابك وتُحذف عناوينك ومفضلاتك وبيانات الاتصال الخاصة بك. تُحفظ سجلات الطلبات والفواتير طوال المدة التي يفرضها القانون. إذا كان لديك طلب مفتوح، يُبتّ في طلب الحذف بعد تسليمه.',
    reason: 'ملاحظة (اختياري)',
    understood: 'أدرك أن حسابي سيُغلق وأنه لا يمكن التراجع عن ذلك.',
    requestErasure: 'إرسال طلب الحذف',
    erasureSent: 'تم استلام طلب الحذف. سنرسل إليك النتيجة بالبريد الإلكتروني.',
    erasureOpen: 'لديك طلب حذف مفتوح؛ وسيصلك إشعار بالبريد الإلكتروني عند البتّ فيه.',
    myRequests: 'طلباتي',
    dueBy: 'في موعد أقصاه {{date}}',
    kinds: {
      export: 'نسخة من البيانات',
      erasure: 'الحذف',
      info: 'طلب معلومات',
      rectification: 'التصحيح',
      objection: 'الاعتراض',
      other: 'أخرى',
    },
    statuses: {
      received: 'مستلم',
      in_progress: 'قيد المعالجة',
      completed: 'تم البتّ فيه',
      rejected: 'غير مقبول',
    },
  },
  consentsNote: 'تُرسل إشعارات الطلبات والشحن بصرف النظر عن هذه الإعدادات.',
  coupon: 'رمز الخصم',
  createAccount: 'إنشاء حساب',
  currentPassword: 'كلمة المرور الحالية',
  dealerBar: 'تُعرض أسعار الموزّعين ({{company}}).',
  dealerOf: 'سجّلت الدخول كموزّع لدى {{company}} وتظهر لك أسعار الموزّعين.',
  dealerPrice: 'سعر الموزّع',
  dealership: 'الانضمام كموزّع',
  discount: 'الخصم ({{code}})',
  documents: 'المستندات (شهادة التسجيل الضريبي وغيرها)',
  documentsHint: 'PDF أو JPEG أو PNG؛ بحد أقصى 10 MB. لا يراها إلا موظفو المتجر.',
  email: 'البريد الإلكتروني',
  emailNotVerified: 'البريد الإلكتروني غير موثّق',
  emailVerified: 'تم توثيق بريدك الإلكتروني.',
  feedRegistration: 'رقم تسجيل الأعلاف: {{no}}',
  feedRegistrationProperty: 'رقم تسجيل الأعلاف',
  countryRegistration: 'رقم التسجيل / الترخيص ({{country}}): {{no}}',
  notInCountry: 'هذا المنتج غير معروض للبيع في الدولة التي اخترتها. يمكنك اختيار دولة أخرى من الشريط العلوي.',
  itemNotInCountry: 'هذا المنتج غير معروض للبيع في الدولة المحددة؛ أزله أو غيّر الدولة.',
  marketLabel: 'الدولة والعملة',
  languageLabel: 'اللغة',
  marketOption: '{{name}} ({{currency}})',
  forSpecies: 'مناسب لـ: {{list}}',
  forgot: 'نسيت كلمة المرور',
  forgotTitle: 'نسيت كلمة المرور',
  from: 'ابتداءً من',
  fullName: 'الاسم الكامل',
  goToCart: 'الانتقال إلى السلة',
  homeLead: 'مكمّلات غذائية للقطط والكلاب.',
  itemInsufficient: 'المتوفر في المخزون {{count}} فقط.',
  itemUnavailable: 'هذا المنتج لم يعد متاحًا؛ أزله من السلة.',
  leaflet: 'معلومات المنتج',
  loading: 'جارٍ التحميل…',
  lowStock: 'تبقّى {{count}} فقط',
  lowest30: 'أدنى سعر خلال آخر 30 يومًا: {{price}}',
  discountPercent: 'خصم {{n}}%',
  marketingEmail: 'أرغب في تلقي رسائل البريد الإلكتروني الخاصة بالعروض.',
  marketingLegend: 'موافقات تسويقية اختيارية',
  marketingSms: 'أرغب في تلقي رسائل SMS الخاصة بالعروض.',
  menu: 'القائمة',
  mainMenu: 'القائمة الرئيسية',
  faq: 'الأسئلة الشائعة',
  pagePreviewNotice: 'معاينة الصفحة: أنت ترى المسودة غير المنشورة. هذا الرابط خاص بك وحدك.',
  menuSeeAll: 'الكل: {{label}}',
  homeCrumb: 'الرئيسية',
  qaTitle: 'الأسئلة والأجوبة',
  reviews: {
    title: 'التقييمات',
    empty: 'لا توجد تقييمات لهذا المنتج بعد. يمكن للعملاء الذين اشتروه واستلموه كتابة تقييم.',
    count: 'عدد التقييمات: {{count}}',
    outOf: '{{value}} من 5',
    stars: '{{n}} نجوم',
    distribution: 'توزيع التقييمات',
    verified: 'عملية شراء موثّقة',
    storeReply: 'رد من {{store}}',
    by: '{{name}}',
    sort: 'ترتيب',
    sorts: {
      newest: 'الأحدث',
      rating_desc: 'الأعلى تقييمًا',
      rating_asc: 'الأدنى تقييمًا',
    },
    more: 'عرض المزيد من التقييمات',
    write: 'اكتب تقييمًا',
    signIn: 'سجّل الدخول لكتابة تقييم',
    notPurchased: 'يمكنك تقييم هذا المنتج بعد شرائه من هذا المتجر واستلامه.',
    alreadyReviewed: 'لقد قيّمت هذا المنتج، شكرًا لك.',
    rating: 'تقييمك',
    ratingNames: {
      '1': 'سيئ جدًا',
      '2': 'سيئ',
      '3': 'متوسط',
      '4': 'جيد',
      '5': 'ممتاز',
    },
    reviewTitle: 'العنوان',
    optional: 'اختياري',
    body: 'مراجعتك',
    bodyHint:
      '20 حرفًا على الأقل. صف كيف استخدمت المنتج؛ ولا تذكر بيانات شخصية أو ادعاءات صحية أو أسماء أمراض. يُنشر بعد الموافقة مع اسمك الأول والحرف الأول من اسم عائلتك.',
    submit: 'إرسال التقييم',
    sent: 'شكرًا لك. سيُنشر تقييمك في صفحة المنتج بعد الموافقة.',
  },
  qaEmpty: 'لا توجد أسئلة مُجاب عنها حول هذا المنتج بعد.',
  qaAsk: 'اطرح سؤالًا',
  qaLabel: 'سؤالك',
  qaHint:
    'يُنشر سؤالك مع إجابته في هذه الصفحة بعد المراجعة؛ ولا يظهر إلا اسم مختصر لك. لا تكتب بيانات شخصية مثل الهاتف أو العنوان.',
  qaSubmit: 'إرسال السؤال',
  qaSentNotify: 'تم استلام سؤالك. سنبلغك بالبريد الإلكتروني عند الإجابة عنه.',
  qaSent: 'تم استلام سؤالك. سيُنشر هنا عند الإجابة عنه.',
  qaSignIn: 'سجّل الدخول لطرح سؤال',
  qaAsked: 'سأل {{name}}',
  qaAnswered: 'أجاب {{store}}',
  compare: 'مقارنة',
  compareTitle: 'مقارنة المنتجات',
  compareAdd: 'إضافة إلى المقارنة',
  compareRemove: 'إزالة من المقارنة',
  compareFull: 'يمكن مقارنة 4 منتجات كحد أقصى.',
  compareBar: 'منتجات في المقارنة: {{count}}',
  compareClear: 'مسح القائمة',
  compareEmpty: 'استخدم زر "إضافة إلى المقارنة" في صفحات المنتجات للمقارنة (4 منتجات كحد أقصى).',
  compareShare: 'شارك عنوان هذه الصفحة لإرسال المقارنة إلى الآخرين.',
  compareMissing: 'منتجات لم تعد معروضة للبيع ولا تظهر: {{count}}',
  compareTable: 'مواصفات المنتجات المحددة',
  compareRemoveOne: 'إزالة: {{title}}',
  compareScroll: 'جدول المقارنة (قابل للتمرير أفقيًا)',
  compareRows: {
    product: 'المنتج',
    price: 'السعر',
    unitPrice: 'سعر الوحدة',
    net: 'الكمية الصافية',
    species: 'مناسب لـ',
    composition: 'التركيبة',
    usage: 'طريقة الاستخدام',
  },
  netUnits: {
    g: '{{n}} غ',
    ml: '{{n}} مل',
    piece: '{{n}} قطعة',
  },
  notSpecified: 'غير محدد',
  favoriteAdd: 'إضافة إلى المفضلة',
  favoriteRemove: 'إزالة من المفضلة',
  favoriteLogin: 'سجّل الدخول للإضافة إلى المفضلة',
  favoriteError: 'تعذّر إتمام العملية؛ يُرجى المحاولة مرة أخرى.',
  favorites: 'مفضلتي',
  favoritesEmpty: 'لا توجد منتجات مفضلة بعد. استخدم زر القلب في بطاقات المنتجات لإضافتها.',
  favoritesHidden: 'منتجات مفضلة غير معروضة للبيع حاليًا: {{count}}؛ ستظهر هنا مجددًا عند عودتها.',
  favoritesCount: 'المنتجات: {{count}}',
  favoritesSignIn: 'سجّل الدخول لعرض مفضلتك.',
  relatedProducts: 'منتجات مشابهة',
  galleryLabel: 'صور المنتج',
  galleryShow: 'عرض الصورة {{n}}',
  galleryZoom: 'تكبير الصورة',
  galleryClose: 'إغلاق',
  galleryPrev: 'الصورة السابقة',
  galleryNext: 'الصورة التالية',
  galleryPosition: '{{n}} / {{total}}',
  complementaryProducts: 'يتناسب جيدًا مع',
  share: 'مشاركة',
  shareCopied: 'تم نسخ الرابط.',
  shareFailed: 'تعذّر نسخ الرابط؛ انسخه من شريط العنوان.',
  gtin: 'الباركود (GTIN): {{gtin}}',
  installments: 'حتى {{n}} أقساط بالبطاقة الائتمانية (حسب البطاقة والبنك)',
  returnInfo: {
    title: 'الإرجاع',
    days: 'يمكنك الإرجاع خلال {{days}} يومًا من التسليم.',
    by_mail: 'يتم الإرجاع عبر الشحن.',
    in_store: 'يتم الإرجاع في المتجر.',
    by_mail_or_in_store: 'يتم الإرجاع عبر الشحن أو في المتجر.',
    free: 'شحن الإرجاع مجاني.',
    customer_pays: 'يتحمل المشتري تكلفة شحن الإرجاع.',
    link: 'شروط الإرجاع والانسحاب (بما فيها الاستثناءات)',
  },
  shippingInfo: {
    title: 'الشحن والتوصيل',
    free: 'مجاني',
    price: 'الشحن: {{price}}',
    freeOver: 'مجاني للطلبات بقيمة {{price}} أو أكثر',
    delivery: 'التوصيل المتوقع: {{range}}',
    days: 'مدة التوصيل: {{days}}',
    cod: 'الدفع عند الاستلام متاح',
    note: 'تاريخ التوصيل تقديري وقد يطول خلال العطلات الرسمية. تُحسب تكلفة الشحن الدقيقة في السلة.',
  },
  tableOfContents: 'المحتويات',
  videos: {
    play: 'تشغيل الفيديو: {{title}}',
    notice: 'يُحمَّل الفيديو من {{provider}}؛ وقد يستخدم {{provider}} ملفات تعريف الارتباط عند تشغيله.',
    providers: {
      youtube: 'YouTube',
      vimeo: 'Vimeo',
    },
  },
  documentKinds: {
    analysis_certificate: 'شهادة التحليل',
    leaflet: 'تعليمات الاستخدام',
    safety_data_sheet: 'صحيفة بيانات السلامة',
    registration: 'التسجيل / الاعتماد',
    other: 'مستند',
  },
  documentSize: 'PDF، {{size}}',
  subcategories: 'الفئات الفرعية',
  relatedCategories: 'فئات ذات صلة',
  productCategories: 'فئات هذا المنتج',
  seoFallback: {
    home: '{{store}}: {{categories}}. مكونات المنتجات ومعلومات الاستخدام والمقالات ونقاط البيع.',
    homeNoCategories: 'متجر {{store}} الإلكتروني: مكونات المنتجات ومعلومات الاستخدام والمقالات ونقاط البيع.',
    products:
      'جميع منتجات {{store}}: صفِّ حسب النوع والفئة والعلامة التجارية والسعر، واطّلع على المكونات ومعلومات الاستخدام.',
    category: '{{name}} — {{store}}. اطّلع على مكونات منتجات هذه الفئة ومعلومات استخدامها وأسعارها الحالية.',
    brand: 'جميع منتجات {{name}}: المكونات ومعلومات الاستخدام والأسعار الحالية.',
    brands: 'العلامات التجارية في {{store}} ومنتجات كل علامة.',
    blog: 'مقالات {{store}} حول رعاية الحيوانات الأليفة وتغذيتها.',
    contact: 'تواصل مع {{store}}: نموذج التواصل ومعلومات البائع.',
    legal: '{{title}} لدى {{store}}: النسخة السارية الحالية.',
    bankAccounts: 'الحسابات المصرفية لدى {{store}}: بيانات الحساب ورقم IBAN للدفع بالتحويل المصرفي.',
  },
  llms: {
    categories: 'الفئات',
    pages: 'الصفحات',
    legal: 'النصوص القانونية',
    products: 'جميع المنتجات',
    articles: 'المقالات',
    salesPoints: 'نقاط البيع',
    contact: 'التواصل',
    sitemap: 'خريطة الموقع',
    productList: 'المنتجات',
    articleList: 'أحدث المقالات',
  },
  blog: 'المقالات',
  blogEmpty: 'لم تُنشر أي مقالات بعد.',
  blogAll: 'الكل',
  blogCategories: 'فئات المقالات',
  blogPages: 'صفحات المدونة',
  blogArchive: 'الأرشيف',
  blogArchiveTitle: 'أرشيف المقالات: {{period}}',
  blogArchiveCount: 'المقالات: {{count}}',
  blogArchiveYear: 'مقالات عام {{year}}',
  readingTime: 'قراءة في {{n}} دقيقة',
  publishedOn: 'تاريخ النشر: {{date}}',
  updatedOn: 'تاريخ التحديث: {{date}}',
  byAuthor: 'بقلم {{name}}',
  postReferences: 'المراجع',
  postProducts: 'المنتجات الواردة في هذا المقال',
  postTags: 'الوسوم',
  postHealthNotice:
    'هذا المقال لأغراض المعلومات فقط ولا يغني عن الفحص أو التشخيص أو العلاج. استشر طبيبك البيطري بشأن صحة حيوانك الأليف.',
  postPreviewNotice: 'معاينة المقال: أنت ترى المسودة غير المنشورة. هذا الرابط خاص بك وحدك.',
  allPosts: 'جميع المقالات',
  sliderLabel: 'أبرز العروض',
  bannerGridLabel: 'العروض الترويجية',
  sliderRole: 'عرض شرائح',
  slideRole: 'شريحة',
  slidePosition: '{{n}} من {{total}}',
  slidePrev: 'الشريحة السابقة',
  slideNext: 'الشريحة التالية',
  slideGoTo: 'الانتقال إلى الشريحة {{n}}',
  sliderPause: 'إيقاف التمرير التلقائي',
  sliderPlay: 'بدء التمرير التلقائي',
  announcement: 'إعلان',
  popupClose: 'إغلاق',
  opensInNewTab: '(يُفتح في علامة تبويب جديدة)',
  links: 'الروابط',
  myAccount: 'حسابي',
  myOrders: 'طلباتي',
  newPassword: 'كلمة المرور الجديدة',
  newest: 'منتجات جديدة',
  next: 'التالي',
  prev: 'السابق',
  noOrders: 'ليست لديك طلبات بعد.',
  noPrice: 'هذا المنتج غير معروض للبيع حاليًا.',
  noProducts: 'لا توجد منتجات هنا بعد.',
  noResults: 'لا توجد منتجات تطابق بحثك.',
  offlinePaymentNote:
    'الدفع الإلكتروني غير متاح بعد: يُسجَّل طلبك بحالة "بانتظار الدفع" وسيتواصل معك المتجر بشأن الدفع.',
  orderNo: 'رقم الطلب',
  orderNote: 'ملاحظة الطلب (اختياري)',
  orderPlaced: 'تم تسجيل طلبك: {{number}}',
  orderPlacedLead: 'سيتواصل معك المتجر بشأن الدفع والتوصيل.',
  orderTitle: 'الطلب {{number}}',
  outOfStock: 'غير متوفر',
  pageOf: 'الصفحة {{page}} من {{pages}}',
  pages: 'الصفحات',
  password: 'كلمة المرور',
  passwordChanged: 'تم تغيير كلمة المرور؛ وتم تسجيل الخروج من الجلسات الأخرى.',
  passwordHint: '12 حرفًا على الأقل؛ اختر عبارة يصعب تخمينها.',
  birthdayOptional: 'تاريخ الميلاد (اختياري)',
  birthdayMonth: 'الشهر',
  birthdayDay: 'اليوم',
  birthdayHint:
    'يُستخدم فقط لإرسال رسالة بريد إلكتروني في عيد ميلادك (إذا سمحت بالرسائل)؛ ولا نطلب السنة. يمكنك تركه فارغًا أو حذفه في أي وقت.',
  phoneOptional: 'الهاتف (اختياري)',
  placeOrder: 'تأكيد الطلب ({{total}})',
  previewNotice: 'معاينة: المتجر غير منشور بعد.',
  themePreviewNotice: 'معاينة القالب: أنت ترى المسودة غير المنشورة. يرى الزوار القالب المنشور.',
  themePreviewExit: 'الخروج من المعاينة',
  shopBySpecies: 'تسوّق حسب نوع الحيوان',
  closeMenu: 'إغلاق القائمة',
  designPreviewNotice: 'أنت تعاين التصميم {{variant}} لـ {{experience}}. يرى الزوار التصميم المنشور.',
  designPreviewExit: 'الخروج من المعاينة',
  designExperiences: {
    header: 'القائمة العلوية',
    articles: 'المقالات',
    store_locator: 'نقاط البيع',
    needs_finder: 'احتياجات حيواني الأليف',
  },
  articles: {
    featured: 'مميز',
    latest: 'الأحدث',
    latestArticles: 'أحدث المقالات',
    seeCategory: 'كل مقالات {{category}}',
    searchLabel: 'ابحث في المقالات',
    searchPlaceholder: 'ابحث في المقالات',
    resultsTitle: 'مقالات عن "{{q}}"',
    resultCount: 'تم العثور على {{count}} مقالة',
    noResults: 'لا توجد مقالات مطابقة لبحثك. جرّب كلمة أخرى.',
    allArticles: 'كل المقالات',
    count: '{{count}} مقالة',
  },
  locator: {
    title: 'نقاط البيع',
    metaDescription:
      'اعثر على الوكلاء والمتاجر التي تبيع منتجاتنا حسب الولاية والمنطقة والحي: العنوان والهاتف والاتجاهات وساعات العمل.',
    cityTitle: 'نقاط البيع في {{city}}',
    cityDescription: 'نقاط البيع في {{city}} ({{count}}): العنوان والهاتف والاتجاهات وساعات العمل.',
    districtTitle: 'نقاط البيع في {{district}}، {{city}}',
    districtDescription: 'نقاط البيع في {{district}}، {{city}} ({{count}}): العنوان والهاتف والاتجاهات.',
    city: 'الولاية',
    district: 'المنطقة',
    neighbourhood: 'الحي',
    allCities: 'كل الولايات',
    allDistricts: 'كل المناطق',
    allNeighbourhoods: 'كل الأحياء',
    chooseCityFirst: 'اختر الولاية أولًا',
    optionCount: '{{name}} ({{count}})',
    search: 'ابحث بالاسم أو العنوان',
    searchPlaceholder: 'اسم المتجر، الحي، الشارع',
    useLocation: 'استخدم موقعي',
    geoLocating: 'جارٍ تحديد الموقع…',
    geoClear: 'إلغاء الترتيب حسب القرب',
    geoPrivacy: 'يُستخدم موقعك على هذا الجهاز فقط لترتيب أقرب النقاط، ولا يُرسل إلينا.',
    geoOk: 'أقرب النقاط في الأعلى. لم يغادر موقعك هذا الجهاز.',
    geoDenied: 'لم يُمنح إذن الموقع. يمكنك البحث باختيار الولاية والمنطقة.',
    geoUnavailable: 'تعذّر تحديد الموقع. يمكنك البحث باختيار الولاية والمنطقة.',
    count: '{{count}} نقطة بيع',
    results: 'نقاط البيع',
    noMatch: 'لا توجد نقطة بيع تطابق اختيارك.',
    noPoints: 'لا توجد نقاط بيع مدرجة بعد. يمكنك طلب منتجاتنا عبر الإنترنت.',
    clearFilters: 'مسح عوامل التصفية',
    shopOnline: 'تصفح المنتجات',
    todayOpen: 'مفتوح اليوم: {{hours}}',
    todayClosed: 'مغلق اليوم',
    hours: 'ساعات العمل',
    closed: 'مغلق',
    meters: '{{value}} م',
    km: '{{value}} كم',
    directions: 'الاتجاهات',
    directionsTo: 'الاتجاهات إلى {{name}} (خرائط Google، تُفتح في علامة تبويب جديدة)',
    mapNote: 'الخريطة ملخص مرئي؛ المعلومات نفسها موجودة في عوامل التصفية والقائمة.',
    osmAttribution: 'تم تحديد بعض المواقع من العناوين: © مساهمو OpenStreetMap',
    allTurkey: 'كل تركيا',
    showMap: 'عرض على الخريطة',
    hideMap: 'إخفاء الخريطة',
    byCity: 'حسب الولاية',
    byDistrict: 'المناطق',
    regions: 'المناطق الجغرافية',
  },
  product: 'المنتج',
  products: 'المنتجات',
  profile: 'الملف الشخصي',
  quantity: 'الكمية',
  register: 'إنشاء حساب',
  registerTitle: 'إنشاء حساب',
  remove: 'إزالة',
  removeCoupon: 'إزالة رمز الخصم {{code}}',
  requestNewLink: 'اطلب رابطًا جديدًا.',
  resetSent: 'إذا كان هناك حساب مرتبط بهذا البريد الإلكتروني، فقد أُرسل رابط إليه.',
  resetTitle: 'تعيين كلمة مرور جديدة',
  resetUnavailable:
    'إرسال البريد الإلكتروني غير متاح حاليًا. يُرجى التواصل مع المتجر لإعادة تعيين كلمة المرور.',
  resultCount: 'المنتجات: {{count}}',
  save: 'حفظ',
  savePassword: 'حفظ كلمة المرور',
  saved: 'تم الحفظ.',
  search: 'بحث',
  searchPlaceholder: 'ابحث عن منتجات أو مكوّنات',
  searchResults: 'نتائج "{{q}}"',
  sendLink: 'إرسال الرابط',
  shipping: 'الشحن',
  shippingLater: 'يُحدَّد عند الطلب',
  signIn: 'تسجيل الدخول',
  signInTitle: 'تسجيل الدخول',
  signOut: 'تسجيل الخروج',
  skipToContent: 'الانتقال إلى المحتوى',
  sku: 'رمز المنتج (SKU): {{sku}}',
  sort: 'الترتيب',
  species: 'النوع',
  status: 'الحالة',
  submitApplication: 'إرسال الطلب',
  subtotal: 'المجموع الفرعي',
  summary: 'ملخص الطلب',
  taxExcluded: 'غير شامل ضريبة القيمة المضافة',
  taxIncluded: 'شامل ضريبة القيمة المضافة',
  taxIncludedLine: 'ضريبة القيمة المضافة المتضمنة',
  taxLine: 'ضريبة القيمة المضافة',
  total: 'الإجمالي',
  unavailableItem: 'منتج غير متاح',
  verifyTitle: 'توثيق البريد الإلكتروني',
  viewOrder: 'عرض الطلب',
  proceedToCheckout: 'المتابعة لإتمام الطلب',
  shippingAtCheckout: 'يُحسب عند إتمام الطلب',
  checkoutTitle: 'إتمام الطلب',
  contactTitle: 'بيانات الاتصال',
  contactLead: 'تُرسل تحديثات الطلب والشحن إلى هذا العنوان.',
  memberCheckoutHint: 'لديك حساب؟ سجّل الدخول لترى طلباتك في حسابك.',
  phone: 'الهاتف',
  deliveryTitle: 'عنوان التوصيل',
  newAddress: 'إدخال عنوان آخر',
  billingTitle: 'بيانات الفوترة',
  billingSame: 'عنوان الفوترة هو نفسه عنوان التوصيل',
  corporateInvoice: 'فاتورة باسم شركة',
  shippingTitle: 'الشحن',
  free: 'مجاني',
  freeOver: 'مجاني للطلبات بقيمة {{amount}} أو أكثر',
  estimatedDays: 'التوصيل المتوقع: {{days}} أيام عمل',
  shippingNotAvailable: 'غير متاح لهذه السلة',
  paymentTitle: 'طريقة الدفع',
  installmentsUpTo: 'حتى {{count}} أقساط',
  codFee: 'رسوم الدفع عند الاستلام',
  codFeeHint: 'رسوم الخدمة: {{fee}}',
  codMaxHint: 'للطلبات حتى {{amount}}',
  codNotForShipping: 'غير متاح مع طريقة الشحن المحددة',
  creditAvailable: 'الحد المتاح في الحساب الآجل: {{amount}}',
  creditOverdueBlock: 'الحساب الآجل غير متاح لوجود دين متأخر عليك ({{amount}}).',
  creditCurrencyBlock: 'الحساب الآجل غير متاح بهذه العملة.',
  quantityRule: 'طلب الموزّع: {{min}} على الأقل، وبمضاعفات {{step}}.',
  itemBelowMin: 'مطلوب {{min}} على الأقل.',
  itemNotMultiple: 'يجب أن يكون من مضاعفات {{step}}.',
  minOrderNotMet: 'الحد الأدنى لطلب الموزّع هو {{min}}. أضف {{missing}} إضافية لتتمكن من الطلب.',
  approval: {
    title: 'يلزم الحصول على موافقة المسؤول المفوّض في الشركة',
    request: 'إرسال إلى المسؤول المفوّض للموافقة',
    noteLabel: 'ملاحظة إلى المسؤول المفوّض (اختياري)',
    send: 'إرسال للموافقة',
    pending: 'أُرسل إلى المسؤول المفوّض للموافقة في {{date}}؛ بانتظار الموافقة. تغيير السلة يُبطل الطلب.',
    withdraw: 'سحب الطلب',
    rejected: 'رفض {{name}} السلة.',
    reason: 'السبب: {{reason}}',
    stale: 'تغيّرت السلة بعد إرسالها للموافقة؛ أرسل السلة الحالية مرة أخرى.',
    approved: 'وافق {{name}} على هذه السلة في {{date}}. يمكنك إتمام الطلب ما دامت السلة دون تغيير.',
    note: 'ملاحظة: {{note}}',
    ownerTitle: 'طلبات بانتظار الموافقة',
    ownerLead:
      'سلال المشترين التي تتجاوز حد الطلب المسموح لهم. يقدّم المشتري السلة المعتمدة من صفحة إتمام الطلب الخاصة به.',
    nonePending: 'لا توجد طلبات بانتظار الموافقة.',
    requestOf: 'طلب موافقة من {{name}}',
    goodsTotal: 'إجمالي البضائع: {{total}}',
    requestNote: 'ملاحظة: {{note}}',
    approve: 'موافقة',
    reject: 'رفض',
    rejectReason: 'سبب الرفض',
    rejectSubmit: 'رفض مع ذكر السبب',
    approvedDone: 'تمت الموافقة على سلة {{name}}.',
    rejectedDone: 'تم رفض سلة {{name}}.',
    history: 'الطلبات المحسومة',
    requester: 'مقدّم الطلب',
    statuses: {
      pending: 'بالانتظار',
      approved: 'تمت الموافقة',
      rejected: 'مرفوض',
      cancelled: 'مسحوب',
      used: 'تم الطلب',
    },
    orderLine: 'موافقة الشركة: {{name}}',
  },
  po: {
    title: 'أمر الشراء (PO)',
    lead: {
      none: 'اختياري: يمكنك إضافة رقم أمر الشراء الخاص بشركتك ومستنده.',
      number: 'تشترط شركتك إدخال رقم أمر الشراء (PO) في الطلبات.',
      number_and_document: 'تشترط شركتك إدخال رقم أمر الشراء (PO) ومستنده في الطلبات.',
    },
    number: 'رقم PO',
    numberOptional: 'رقم PO (اختياري)',
    document: 'مستند PO',
    documentOptional: 'مستند PO (اختياري)',
    documentHint: 'PDF أو JPEG أو PNG؛ حتى 10 MB. لا يرى المستند إلا المتجر.',
    uploaded: 'تم إرفاق {{name}}.',
    remove: 'إزالة',
    missing: 'أكمل بيانات أمر الشراء لتأكيد الطلب.',
    listLabel: 'PO: {{number}}',
    orderLine: 'أمر الشراء: {{number}}',
    orderDocument: 'المستند: {{name}}',
  },
  quotes: {
    title: 'عروض الأسعار',
    linkLead: 'عروض الأسعار التي طلبتها أو تلقيتها',
    detailTitle: 'عرض السعر {{number}}',
    empty: 'لا توجد عروض أسعار بعد. استخدم "طلب عرض سعر" في السلة لطلب سعر.',
    number: 'رقم عرض السعر',
    validUntil: 'صالح حتى',
    validUntilLine: 'صالح حتى {{date}}',
    versionLine: 'الإصدار {{version}}',
    statuses: {
      requested: 'تم استلام الطلب',
      draft: 'قيد الإعداد',
      sent: 'بانتظار ردّك',
      ordered: 'تم الطلب',
      rejected: 'مرفوض',
      cancelled: 'ملغى',
      expired: 'منتهي الصلاحية',
    },
    requestedLead: 'تم استلام طلبك. سيظهر عرض السعر هنا بمجرد أن يرسله المتجر.',
    draftLead: 'يُعدّ المتجر عرض السعر أو يحدّثه؛ ويمكنك قبوله بعد إرساله.',
    rejectedLead: 'رفضت عرض السعر: {{reason}}',
    expiredLead: 'انتهت صلاحية عرض السعر ولا يمكن قبوله. تواصل مع المتجر للحصول على عرض جديد.',
    note: 'ملاحظة المتجر',
    requestNoteLine: 'ملاحظتك: {{note}}',
    lines: 'المنتجات المعروضة',
    product: 'المنتج',
    listPrice: 'سعر القائمة',
    unitPrice: 'سعر العرض',
    taxIncl: 'شامل ضريبة القيمة المضافة',
    taxExcl: 'غير شامل ضريبة القيمة المضافة',
    taxLine: 'ضريبة القيمة المضافة: {{tax}}',
    saving: 'الخصم مقارنة بسعر القائمة: {{amount}}',
    shippingNote: 'يُختار الشحن وطريقة الدفع عند الطلب.',
    accept: 'قبول وطلب',
    acceptLead:
      'عند القبول تُستبدل سلتك بهذا العرض (وتُزال المنتجات الأخرى) وتنتقل إلى إتمام الطلب؛ وتُطبَّق أسعار العرض.',
    reject: 'رفض',
    rejectReason: 'السبب',
    confirmReject: 'رفض عرض السعر',
    print: 'طباعة',
    view: 'عرض عرض السعر',
    inCart:
      'تحتوي السلة على عرض السعر {{number}} (الإصدار {{version}}، صالح حتى {{date}}). تُطبَّق أسعار العرض؛ ولا يمكن تغيير السلة.',
    release: 'إزالة عرض السعر من السلة',
    request: 'طلب عرض سعر',
    requestLead:
      'اطلب من المتجر سعرًا خاصًا للمنتجات الموجودة في سلتك. تبقى سلتك كما هي؛ ويظهر عرض السعر في حسابي ← عروض الأسعار.',
    requestNote: 'ملاحظتك (اختياري)',
    sendRequest: 'إرسال طلب عرض السعر',
    requested: 'تم استلام طلب عرض السعر {{number}}.',
  },
  quickOrder: {
    title: 'الطلب السريع',
    linkLead: 'طلب بالجملة حسب رمز المنتج والكمية',
    lead: 'اكتب رمز منتج وكمية في كل سطر (مثل "ZG-OM-60;12"). يمكنك لصق عمودين من Excel أو اختيار ملف CSV. تحقّق أولًا؛ وتُضاف الأسطر الصالحة إلى السلة.',
    lines: 'رمز المنتج والكمية (منتج واحد في كل سطر)',
    file: 'أو اختر ملف CSV',
    check: 'تحقّق',
    addToCart: 'إضافة المنتجات إلى السلة ({{count}})',
    preview: 'نتيجة التحقق',
    sku: 'رمز المنتج (SKU)',
    product: 'المنتج',
    unitPrice: 'سعر الوحدة',
    ok: 'يمكن إضافته',
    added: 'تمت إضافة المنتجات إلى السلة: {{count}}.',
    empty: 'لا توجد أسطر قابلة للقراءة. اكتب رمز منتج وكمية في كل سطر.',
    badLines: 'تم تخطي الأسطر غير المقروءة: {{lines}} (يجب أن تكون الكمية بين 1 و999).',
    dealersOnly: 'الطلب السريع متاح لحسابات الموزّعين.',
    statuses: {
      not_found: 'لم يُعثر على رمز المنتج',
      unavailable: 'غير معروض للبيع',
      insufficient_stock: 'المخزون غير كافٍ (حتى {{available}})',
      below_min_quantity: '{{min}} على الأقل',
      not_pack_multiple: 'مضاعفات {{step}}',
      cart_line_limit: 'تتسع السلة لـ {{max}} منتجات مختلفة كحد أقصى',
    },
  },
  reorder: {
    title: 'إعادة الطلب',
    button: 'إعادة هذا الطلب',
    added: 'تمت إضافة المنتجات إلى السلة بأسعار اليوم: {{count}}.',
  },
  companyLocation: 'الشركة: {{label}}',
  companyInvoiceNote: 'تُصدر الفاتورة باسم الشركة ومكتب الضرائب والرقم الضريبي.',
  memberLimit:
    'حد الطلب الخاص بك: {{amount}} (شامل الشحن). تحتاج الطلبات التي تتجاوزه إلى موافقة المسؤول المفوّض في الشركة.',
  company: {
    title: 'شركتي',
    roles: {
      owner: 'المسؤول المفوّض',
      buyer: 'مشترٍ',
      viewer: 'عرض فقط',
    },
    roleHelp: {
      owner: 'تطلب باسم الشركة، وترى طلبات الشركة وكشف الحساب والمستخدمين، وتدير المواقع.',
      buyer: 'تطلب باسم الشركة وترى طلباتك الخاصة.',
      viewer: 'ترى أسعار الموزّعين وطلبات الشركة وكشف الحساب؛ ولا يمكنك الطلب.',
    },
    locations: 'المواقع (فرع، توصيل، فوترة)',
    noLocations: 'لا توجد مواقع بعد.',
    addLocation: 'إضافة موقع',
    editLocation: 'تعديل الموقع',
    edit: 'تعديل',
    delete: 'حذف',
    confirmDelete: 'هل تريد حذف الموقع "{{name}}"؟ لا تتغير العناوين في الطلبات السابقة.',
    deleted: 'تم حذف الموقع.',
    saved: 'تم حفظ الموقع.',
    locationLabel: 'اسم الموقع (مثل المقر الرئيسي)',
    defaultShipping: 'التوصيل الافتراضي',
    defaultBilling: 'الفوترة الافتراضية',
    makeDefaultShipping: 'تعيين كعنوان التوصيل الافتراضي',
    makeDefaultBilling: 'تعيين كعنوان الفوترة الافتراضي',
    saveLocation: 'حفظ الموقع',
    members: 'مستخدمو الشركة',
    membersLead: 'لإضافة شخص لديه حساب في المتجر بالفعل، أو لتغيير دورك، تواصل مع المتجر.',
    memberName: 'المستخدم',
    role: 'الدور',
    limit: 'حد الطلب',
    notActivated: 'لم يُفعَّل بعد',
    actions: 'الإجراءات',
    you: '(أنت)',
    memberEdit: 'تعديل',
    memberEditFor: 'تعديل: {{name}}',
    memberFormFor: '{{name}}: الدور والحد',
    memberSave: 'حفظ',
    memberSaved: 'تم تحديث {{name}}.',
    remove: 'إزالة من الشركة',
    removeFor: 'إزالة من الشركة: {{name}}',
    removeConfirm:
      'هل تريد إزالة {{name}} من الشركة؟ لن يُحذف حسابه، لكنه لن يرى أسعار الموزّعين ولا بيانات الشركة بعد الآن.',
    removed: 'تمت إزالة {{name}} من الشركة.',
    resendLink: 'إعادة إرسال الرابط',
    resendLinkFor: 'إعادة إرسال الرابط: {{name}}',
    linkResent: 'أُرسل رابط تفعيل جديد إلى {{email}}؛ لم يعد الرابط السابق صالحًا.',
    limitField: 'حد الطلب (ليرة تركية)',
    limitHint: 'السلال التي تتجاوز هذا المبلغ تصل إليك للموافقة. اتركه فارغًا لعدم وجود حد.',
    limitInvalid: 'اكتب المبلغ مثل 5000 أو 2500.50.',
    inviteTitle: 'دعوة مستخدم',
    inviteLead:
      'يتلقى المدعو رابط تفعيل عبر البريد الإلكتروني ويعيّن كلمة مروره بنفسه. يمكنك إرسال {{perDay}} دعوة كحد أقصى يوميًا.',
    inviteName: 'الاسم الكامل',
    inviteEmail: 'البريد الإلكتروني',
    invitePhone: 'الهاتف (اختياري)',
    inviteSubmit: 'إرسال الدعوة',
    invited: 'أُرسلت الدعوة إلى {{email}}.',
    inviteSetupRequired:
      'يلزم الإعداد: لا يمكن إرسال الدعوات بعد لأن خدمة البريد الإلكتروني للمتجر غير مُعدّة. لإضافة مستخدمين، تواصل مع المتجر.',
    orders: 'طلبات الشركة',
    placedBy: 'مقدّم الطلب',
    companyOrderNote:
      'يعود هذا الطلب إلى مستخدم آخر في شركتك؛ ويمكنك عرضه فقط. يتولى الشخص الذي قدّمه عمليات الإرجاع والدفع.',
  },
  balancePay: {
    open: 'الدفع بالبطاقة',
    title: 'سداد الرصيد بالبطاقة',
    modeBalance: 'الرصيد بالكامل ({{amount}})',
    modeItems: 'البنود المحددة',
    modeCustom: 'مبلغ آخر',
    itemLabel: '{{item}} — {{amount}}',
    amountLabel: 'المبلغ ({{currency}})',
    amountHint: 'يمكنك دفع {{max}} كحد أقصى.',
    amountInvalid: 'أدخل المبلغ بالصيغة 1,250.50.',
    lead: 'يُحصَّل المبلغ عبر الصفحة الآمنة لمزوّد خدمة الدفع (حتى {{installments}} أقساط). ويُسجَّل في حسابك الجاري ويُخصم من أقدم دين مستحق عليك.',
    submit: 'دفع {{amount}}',
    unavailable: 'الدفع بالبطاقة غير متاح حاليًا. يمكنك سداد رصيدك عبر التحويل البنكي.',
    recent: 'مدفوعاتك الأخيرة بالبطاقة',
    amount: 'المبلغ',
    status: 'الحالة',
    statuses: {
      pending: 'قيد الانتظار',
      captured: 'مستلم',
      failed: 'فشل',
      expired: 'منتهي الصلاحية',
      requires_action: 'قيد المراجعة',
    },
    resultTitle: 'دفعة الحساب الجاري',
    notFound: 'لم يُعثر على الدفعة.',
    result: {
      pending: 'جارٍ التحقق من دفعتك…',
      captured: 'تم استلام دفعتك البالغة {{amount}} وتسجيلها في حسابك الجاري.',
      failed: 'فشل الدفع. لم يُخصم أي مبلغ من بطاقتك؛ ويمكنك المحاولة مرة أخرى.',
      expired: 'لم يكتمل الدفع. لم يُخصم أي مبلغ من بطاقتك؛ ويمكنك المحاولة مرة أخرى.',
      requires_action: 'دفعتك قيد المراجعة. ستظهر النتيجة في حسابك الجاري؛ وسنتواصل معك عند الحاجة.',
    },
    backToAccount: 'العودة إلى حسابي الجاري',
  },
  dealerLedger: {
    bhPendingPayments: 'مدفوعاتك التي لم تُسجَّل بعد في السجل المحاسبي',
    bhPending: 'طلبات لم تُسجَّل بعد في حساباتنا',
    bhSource: 'الرصيد والحركات من سجلنا المحاسبي (BizimHesap)، آخر تحديث {{date}}.',
    bhNever: 'لم يتم جلب السجل المحاسبي (BizimHesap) بعد.',
    bhStale: 'تعذّر التحديث حاليًا؛ يُعرض آخر سجل تم استلامه.',
    bhStatement: 'كشف الحساب (السجل المحاسبي)',
    siteStatement: 'حركات الطلبات والمدفوعات على هذا الموقع',
    title: 'كشف حسابي',
    lead: 'تستحق طلبات الحساب الآجل بعد {{days}} يومًا من تاريخ الطلب. تُخصم المدفوعات من أقدم مبلغ مستحق أولًا.',
    leadNoTerm: 'تُخصم المدفوعات من أقدم مبلغ مستحق أولًا.',
    balance: 'الرصيد (المبلغ المستحق عليك)',
    overdue: 'متأخر السداد',
    available: 'الحد المتاح في الحساب الآجل',
    openItems: 'البنود غير المسددة',
    item: 'الطلب / القيد',
    dueDate: 'تاريخ الاستحقاق',
    open: 'المتبقي',
    daysOverdue: 'متأخر {{days}} يومًا',
    statement: 'كشف الحساب (آخر 12 شهرًا)',
    date: 'التاريخ',
    description: 'الوصف',
    debit: 'مدين',
    credit: 'دائن',
    running: 'الرصيد',
    broughtForward: 'الرصيد المرحّل',
    download: 'تنزيل كشف الحساب (CSV)',
    kinds: {
      order: 'طلب',
      order_change: 'تعديل الطلب',
      order_payment: 'دفعة الطلب',
      payment: 'دفعة',
      opening: 'الرصيد الافتتاحي',
      adjustment: 'تسوية',
      reversal: 'تصحيح (قيد عكسي)',
    },
    reasons: {
      placed: 'تم تقديم الطلب',
      cancelled: 'ملغى',
      partial_cancel: 'إلغاء جزئي',
      edited: 'تم تعديل الطلب',
      refunded: 'استرداد المبلغ',
      paid: 'تم استلام الدفعة',
      refund_paid: 'تم صرف المبلغ المسترد',
      changed: 'تغيّر المبلغ',
      card_balance: 'الدفع بالبطاقة',
    },
  },
  contractsTitle: 'المعلومات المسبقة والعقد',
  contractsLead:
    'اقرأ النصوص أدناه قبل تأكيد الطلب. تُحفظ النصوص التي توافق عليها مع طلبك، ويمكنك الاطلاع عليها في أي وقت من صفحة طلبك.',
  fillToSeeContracts: 'تظهر المبالغ ونصوص العقد هنا بعد اختيار العنوان وطريقة الشحن وطريقة الدفع.',
  quoteUpdating: 'جارٍ تحديث المبالغ…',
  confirmAndPay: 'تأكيد الطلب والدفع · {{total}}',
  confirmOrder: 'تأكيد الطلب · {{total}}',
  placingOrder: 'جارٍ إنشاء طلبك…',
  orderReceivedTitle: 'تم استلام طلبك',
  orderReceivedLead: 'رقم طلبك هو {{number}}.',
  customerService: 'خدمة العملاء',
  contactPageTitle: 'اتصل بنا',
  contactForm: {
    title: 'راسلنا',
    presets: {
      name: 'الاسم الكامل',
      email: 'بريدك الإلكتروني',
      phone: 'الهاتف',
      message: 'رسالتك',
    },
    submit: 'إرسال',
    sent: 'تم استلام رسالتك. سنرد عليك عبر البريد الإلكتروني في أقرب وقت ممكن.',
    trap: 'اترك هذا الحقل فارغًا',
  },
  formChoose: 'اختر',
  formPrivacy: 'تُعالَج بياناتك الشخصية فقط للرد على طلبك. التفاصيل:',
  phoneLabel: 'الهاتف',
  emailLabel: 'البريد الإلكتروني',
  contactOrderHint: 'إذا كنت تكتب بشأن طلب، فأضف رقم طلبك. لعرض طلبك:',
  orderLookupTitle: 'الاستعلام عن الطلب',
  stockAlert: {
    open: 'أعلمني عند التوفر',
    lead: 'سنرسل إليك رسالة بريد إلكتروني واحدة عند عودة هذا الخيار إلى المخزون. لا حاجة إلى حساب.',
    email: 'البريد الإلكتروني',
    notice:
      'يُستخدم عنوانك لهذا الإشعار فقط؛ تُرسل رسالة بريد إلكتروني واحدة عند عودة المنتج إلى المخزون، ويظل الطلب ساريًا لمدة 6 أشهر. لا تُرسل أي رسائل إعلانية.',
    submit: 'أعلمني',
    sent: 'تم. سنرسل إليك بريدًا إلكترونيًا عند عودة المنتج إلى المخزون.',
  },
  tender: {
    title: 'بطاقة هدية أو رصيد المتجر',
    giftCard: 'رمز بطاقة الهدية',
    apply: 'تطبيق',
    remove: 'إزالة البطاقة',
    applied: 'تم تطبيق بطاقة الهدية …{{last4}} (الرصيد {{balance}}).',
    useCredit: 'استخدام رصيدي في المتجر ({{balance}})',
    coveredHint: 'إذا غُطّي المبلغ بالكامل، فلن تُستخدم طريقة الدفع المختارة.',
    giftCardLine: 'بطاقة هدية (…{{last4}})',
    storeCreditLine: 'رصيد المتجر',
    due: 'المبلغ المستحق',
    confirmCovered: 'تأكيد الطلب (لا يوجد مبلغ متبقٍّ للدفع)',
  },
  credit: {
    title: 'رصيدي في المتجر',
    lead: 'استخدم رصيدك في المتجر عند إتمام الطلب عبر «استخدام رصيدي في المتجر».',
    history: 'حركات رصيد المتجر',
    date: 'التاريخ',
    kind: 'العملية',
    amount: 'المبلغ',
    kinds: {
      grant: 'أضافه المتجر',
      refund: 'أُضيف المبلغ المسترد كرصيد',
      redeem: 'استُخدم في طلب',
      release: 'أُعيد من طلب ملغى',
      adjust: 'تصحيح',
    },
  },
  loyalty: {
    tierLine: 'خصم عضوية {{tier}} ({{percent}}%)',
    tierShipping: 'عضوية {{tier}}: شحن مجاني',
    usePoints: 'استخدام نقاطي ({{points}} نقطة = {{value}})',
    minRedeem: 'تحتاج إلى {{points}} نقطة على الأقل لاستخدامها (رصيدك الحالي {{balance}}).',
    pointsLine: 'نقاط الولاء ({{points}} نقطة)',
    earn: 'ستكسب {{points}} نقطة من هذا الطلب؛ تُضاف إلى حسابك بعد {{days}} يوم من التسليم.',
    earnNow: 'ستكسب {{points}} نقطة من هذا الطلب؛ تُضاف إلى حسابك بعد التسليم.',
    title: 'نقاطي',
    balance: '{{points}} نقطة',
    balanceValue: 'بقيمة {{value}}؛ استخدمها عند إتمام الطلب عبر «استخدام نقاطي».',
    tier: 'مستواك: {{tier}}',
    noTier: 'ليس لديك مستوى بعد.',
    perks: 'مزاياك: {{perks}}',
    perkDiscount: 'خصم {{percent}}%',
    perkShipping: 'شحن مجاني',
    nextTier: 'يتبقى {{amount}} للوصول إلى مستوى {{tier}} (مشترياتك في آخر 12 شهرًا: {{spent}}).',
    topTier: 'أنت في أعلى مستوى (مشترياتك في آخر 12 شهرًا: {{spent}}).',
    expiring: 'تنتهي صلاحية {{points}} نقطة خلال 30 يومًا.',
    rules: 'شروط البرنامج',
    ruleEarn: 'تكسب {{points}} نقطة مقابل كل {{one}} تنفقها (باستثناء الشحن والجزء المدفوع بالنقاط).',
    ruleValue: '{{points}} نقطة = {{one}}.',
    ruleHold: 'تُضاف النقاط بعد {{days}} يوم من التسليم.',
    ruleHoldNow: 'تُضاف النقاط بعد التسليم.',
    ruleExpiry: 'النقاط المكتسبة صالحة لمدة {{months}} شهر؛ وتُستخدم النقاط الأقرب انتهاءً أولًا.',
    ruleNoExpiry: 'لا تنتهي صلاحية النقاط.',
    ruleMin: 'يلزم {{points}} نقطة على الأقل لاستخدامها عند الدفع.',
    ruleRefund: 'تُخصم النقاط المقابلة للمبالغ المستردة؛ وتُعاد النقاط المستخدمة في طلب ملغى.',
    tiersTitle: 'المستويات (حسب المشتريات في آخر 12 شهرًا)',
    tierRow: '{{tier}}: {{min}} فأكثر',
    history: 'حركات النقاط',
    date: 'التاريخ',
    kind: 'النوع',
    points: 'النقاط',
    kinds: {
      earn: 'مكتسبة',
      redeem: 'استُخدمت في طلب',
      release: 'أُعيدت',
      reverse: 'خُصمت (استرداد المبلغ)',
      expire: 'انتهت صلاحيتها',
      adjust: 'تصحيح',
    },
  },
  referral: {
    title: 'ادعُ صديقًا',
    lead: 'يحصل صديقك الذي يقدّم طلبه الأول باستخدام رمز دعوتك على {{friend}}. وبعد {{days}} يوم من تسليم طلب صديقك، تحصل على رمز خصم يمنحك {{referrer}}.',
    leadNow:
      'يحصل صديقك الذي يقدّم طلبه الأول باستخدام رمز دعوتك على {{friend}}. وبمجرد تسليم طلب صديقك، تحصل على رمز خصم يمنحك {{referrer}}.',
    offerPercent: 'خصم {{percent}}%',
    offerFixed: 'خصم {{value}}',
    offerMin: '{{offer}} (للطلبات بقيمة {{min}} فأكثر)',
    getCode: 'الحصول على رمز دعوتي',
    yourCode: 'رمز دعوتك:',
    link: 'رابط دعوتك',
    copy: 'نسخ الرابط',
    share: 'مشاركة',
    shareTitle: 'رابط دعوتي للحصول على خصم على الطلب الأول',
    copied: 'تم نسخ الرابط.',
    copyFailed: 'تعذّر النسخ؛ حدّد الرابط وانسخه بنفسك.',
    stats: 'الدعوات المعلّقة: {{pending}}. المكافآت المكتسبة: {{rewarded}}.',
    rules: 'شروط البرنامج',
    ruleFirst: 'يسري الخصم على الطلب الأول لصديقك فقط. لا يمكنك استخدام رمزك الخاص.',
    ruleHold:
      'تُمنح المكافأة بعد {{days}} يوم من تسليم طلب صديقك. لا تُمنح أي مكافأة إذا أُلغي الطلب أو أُرجع.',
    ruleHoldNow: 'تُمنح المكافأة بمجرد تسليم طلب صديقك. لا تُمنح أي مكافأة إذا أُلغي الطلب أو أُرجع.',
    ruleValid: 'رمز خصم المكافأة صالح لمدة {{days}} يوم ولا يمكن استخدامه إلا في حسابك.',
    ruleMax: 'يمكنك الحصول على {{max}} مكافأة كحد أقصى.',
    ruleNoContact: 'لا يراسل المتجر صديقك نيابةً عنك أبدًا؛ فأنت من يشارك الرابط بنفسك.',
    rewardsTitle: 'رموز خصم المكافآت الخاصة بك',
    code: 'الرمز',
    discount: 'الخصم',
    endsAt: 'تاريخ الانتهاء',
    state: 'الحالة',
    states: {
      active: 'متاح',
      used: 'مستخدَم',
      expired: 'منتهي الصلاحية',
    },
    inviteTitle: 'أنت مدعو',
    inviteLead: 'دعاك أحد أصدقائك. تحصل على {{offer}} على طلبك الأول.',
    inviteCode: 'رمز الدعوة:',
    inviteHow:
      'يُطبَّق الرمز تلقائيًا على سلة التسوق؛ ويمكنك أيضًا كتابته بنفسك في حقل «رمز الخصم» في السلة. يسري الخصم على الطلب الأول فقط.',
    inviteStart: 'ابدأ التسوق',
  },
  support: {
    title: 'تذاكر الدعم الخاصة بي',
    empty: 'ليس لديك أي تذاكر دعم بعد.',
    newTicket: 'تذكرة جديدة',
    colTicket: 'التذكرة',
    colStatus: 'الحالة',
    colUpdated: 'آخر تحديث',
    category: 'الموضوع',
    subject: 'العنوان',
    order: 'الطلب المرتبط (اختياري)',
    noOrder: 'بدون طلب',
    message: 'رسالتك',
    messageHint: 'لا تكتب أرقام البطاقات أو كلمات المرور أو رموز التحقق؛ فنحن لا نطلبها منك أبدًا.',
    submit: 'إرسال التذكرة',
    cancel: 'إلغاء',
    categories: {
      order: 'الطلب',
      shipping: 'الشحن والتسليم',
      return: 'الإرجاع والاستبدال',
      payment: 'الدفع والفاتورة',
      product: 'معلومات المنتج',
      account: 'الحساب',
      other: 'أخرى',
    },
    statuses: {
      open: 'قيد المراجعة',
      waiting: 'بانتظار ردك',
      resolved: 'تم الحل',
      closed: 'مغلقة',
    },
    awaitingRating: 'يرجى تقييم مساعدتنا',
    ticketTitle: 'تذكرة دعم #{{number}}',
    orderLine: 'الطلب {{number}}',
    conversation: 'المحادثة',
    you: 'أنت',
    team: 'فريق الدعم',
    resolvedNote:
      'تم وضع علامة «تم الحل» على تذكرتك. إذا استمرت المشكلة، فما عليك سوى الكتابة وستُعاد فتح التذكرة.',
    closedNote: 'هذه التذكرة مغلقة. لموضوع جديد، افتح تذكرة جديدة من صفحة «حسابي».',
    reply: 'ردك',
    sendReply: 'إرسال الرد',
    replySent: 'تم إرسال ردك.',
    rateTitle: 'قيّم مساعدتنا',
    rateLead: 'اختر تقييمًا من 1 (غير راضٍ إطلاقًا) إلى 5 (راضٍ جدًا).',
    score: '{{score}} نقطة',
    comment: 'تعليقك (اختياري)',
    sendRating: 'إرسال التقييم',
    ratingSent: 'شكرًا لك، تم استلام تقييمك.',
    thanks: 'شكرًا على تقييمك: {{rating}} / 5',
    notFound:
      'لم يتم العثور على التذكرة. تأكد من استخدام الرابط الكامل الوارد في البريد الإلكتروني؛ وإذا كان لديك حساب، فسجّل الدخول.',
    keepLink: 'رابط هذه الصفحة خاص بك؛ لا تشاركه مع أحد.',
  },
  chat: {
    launcher: 'الدعم المباشر',
    title: 'الدعم المباشر',
    close: 'إغلاق',
    unavailable: 'الدعم المباشر غير متاح حاليًا. يمكنك مراسلتنا عبر صفحة الاتصال:',
    nobody: 'لا يوجد ممثل متصل حاليًا. يمكنك مراسلتنا عبر صفحة الاتصال:',
    sent: 'تم استلام رسالتك وحفظها كتذكرة دعم. سنرسل ردنا إلى بريدك الإلكتروني.',
    startLead: 'اكتب سؤالك؛ سيرد عليك أحد ممثلينا قريبًا.',
    offlineLead: 'لا يوجد ممثل متصل حاليًا. اترك رسالة وسنرد عليك عبر البريد الإلكتروني.',
    nameOptional: 'اسمك (اختياري)',
    name: 'اسمك',
    emailOptional: 'البريد الإلكتروني (اختياري)',
    email: 'البريد الإلكتروني',
    emailHint: 'إذا انقطعت المحادثة، يمكننا التواصل معك عبر هذا العنوان.',
    emailOfflineHint: 'سنرسل ردنا إلى هذا العنوان.',
    message: 'رسالتك',
    privacy: 'لا تكتب أرقام البطاقات أو كلمات المرور أو رموز التحقق. يُعالَج ما تكتبه فقط للرد على سؤالك:',
    start: 'بدء المحادثة',
    leave: 'إرسال الرسالة',
    messages: 'رسائل المحادثة',
    team: 'فريق الدعم',
    you: 'أنت',
    events: {
      joined: 'انضم أحد ممثلينا إلى المحادثة.',
      closed_visitor: 'لقد أنهيت المحادثة.',
      closed_staff: 'أغلق الممثل المحادثة.',
      closed_idle: 'أُغلقت المحادثة بسبب عدم النشاط.',
      ticket: 'تم حفظ محادثتك كتذكرة دعم؛ سنتواصل معك عبر البريد الإلكتروني.',
    },
    waiting: 'ترتيبك في قائمة الانتظار هو {{position}}؛ سيتصل بك أحد ممثلينا قريبًا.',
    closedTicket: 'انتهت المحادثة؛ تم حفظ موضوعك كتذكرة دعم.',
    closed: 'انتهت المحادثة.',
    newChat: 'محادثة جديدة',
    yourMessage: 'رسالتك',
    send: 'إرسال',
    end: 'إنهاء المحادثة',
  },
  promo: {
    title: 'العروض',
    itemDiscount: 'خصم {{percent}}% في سلة التسوق',
    buyXPayY: 'اشترِ {{buy}} وادفع ثمن {{pay}}: في كل {{buy}} منتجات تحصل على {{free}} من الأقل سعرًا مجانًا',
    tierSubtotalPercent: 'خصم {{percent}}% على السلال بقيمة {{min}} فأكثر',
    tierSubtotalFixed: 'خصم {{value}} على السلال بقيمة {{min}} فأكثر',
    tierQuantityPercent: 'خصم {{percent}}% عند شراء {{min}} منتجات أو أكثر',
    tierQuantityFixed: 'خصم {{value}} عند شراء {{min}} منتجات أو أكثر',
    freeShippingOver: 'شحن مجاني للطلبات بقيمة {{min}} فأكثر',
    freeShipping: 'شحن مجاني',
    until: 'حتى {{date}}',
    targeted: 'يسري العرض على هذا المنتج؛ ويُطبَّق الخصم في سلة التسوق.',
    hintPercent: 'أضف {{amount}} أخرى لتحصل على خصم {{percent}}% على سلتك.',
    hintFixed: 'أضف {{amount}} أخرى لتحصل على خصم {{value}} على سلتك.',
    hintShipping: 'أضف {{amount}} أخرى للحصول على شحن مجاني.',
    shippingFree: 'شحن مجاني',
    coupon: 'رمز الخصم ({{code}})',
  },
  push: {
    title: 'إشعارات المتصفح',
    lead: 'تعرّف على الحملات والمنتجات الجديدة عبر الإشعارات. لا يُطلب الإذن إلا عند الضغط على الزر، ويمكنك إيقافها في أي وقت.',
    enable: 'تفعيل الإشعارات',
    disable: 'إيقاف الإشعارات',
    enabled: 'الإشعارات مفعّلة في هذا المتصفح.',
    disabled: 'تم إيقاف الإشعارات.',
    denied: 'يحظر متصفحك الإشعارات لهذا الموقع. لتفعيلها، غيّر إذن الموقع من إعدادات المتصفح.',
    failed: 'تعذّر تفعيل الإشعارات. حاول مرة أخرى لاحقًا.',
    privacy: 'إشعار الخصوصية',
  },
  newsletter: {
    title: 'النشرة البريدية',
    lead: 'تعرّف على العروض والمنتجات الجديدة والمقالات. يمكنك إلغاء الاشتراك بنقرة واحدة في أي وقت.',
    email: 'بريدك الإلكتروني',
    consent: 'أوافق على تلقي رسائل إلكترونية تجارية عبر البريد الإلكتروني بشأن العروض والإعلانات والمستجدات.',
    privacy: 'إشعار الخصوصية',
    submit: 'اشتراك',
    sent: 'شكرًا لك. افتح الرابط الذي أرسلناه إلى بريدك الإلكتروني لبدء الاشتراك (صالح لمدة 7 أيام). إذا لم تصلك الرسالة، فتحقق من مجلد الرسائل غير المرغوب فيها.',
    confirmTitle: 'أكّد اشتراكك في النشرة البريدية',
    confirmLead: 'اضغط على الزر أدناه للسماح لنا بإرسال النشرة البريدية إلى هذا العنوان.',
    confirm: 'تأكيد الاشتراك',
    confirmed: 'بدأ اشتراكك. يمكنك إلغاء الاشتراك في أي وقت عبر الرابط الموجود أسفل كل نشرة.',
    missingToken: 'الرابط غير مكتمل. افتح الرابط كاملًا من البريد الإلكتروني.',
    unsubscribeTitle: 'إلغاء الاشتراك في الرسائل التسويقية',
    unsubscribeLead: 'سنتوقف عن إرسال الرسائل التسويقية إلى {{address}}.',
    unsubscribeLeadSms: 'سنتوقف عن إرسال الرسائل النصية التسويقية إلى {{address}}.',
    unsubscribe: 'إلغاء الاشتراك',
    unsubscribed: 'تم: لن نرسل بعد الآن رسائل تسويقية إلى {{address}}. ستستمر إشعارات الطلبات والشحن.',
    memberHint: 'إذا كان لديك حساب، يمكنك أيضًا تغيير تفضيلاتك من إعدادات الرسائل في صفحة «حسابي».',
  },
  orderLookupLead:
    'أدخل رقم طلبك والبريد الإلكتروني المستخدم في الطلب. إذا تطابقت البيانات، يُرسل رابط طلبك إلى بريدك الإلكتروني.',
  orderLookupMember: 'إذا طلبت بصفتك عضوًا، يمكنك الاطلاع على طلباتك في حسابك:',
  orderNumber: 'رقم الطلب',
  orderLookupSubmit: 'إرسال الرابط',
  orderLookupSent:
    'إذا تطابقت البيانات مع طلب ما، فسيصل رابط الطلب إلى بريدك الإلكتروني خلال بضع دقائق. وإن لم يصل، فتحقق من مجلد الرسائل غير المرغوب فيها.',
  orderLookupUnavailable:
    'يتعذّر إرسال البريد الإلكتروني حاليًا. يرجى التواصل معنا عبر البيانات الواردة في صفحة الاتصال.',
  bankAccountsTitle: 'حساباتنا المصرفية',
  bankAccountsLead: 'اكتب رقم طلبك (أو رمز الموزّع) في وصف التحويل.',
  bankAccountsEmpty: 'لم تُضف بيانات أي حساب مصرفي بعد.',
  returnsTitle: 'الإرجاع والانسحاب والاستبدال',
  returnLead:
    'لإرجاع منتج أو ممارسة حقك في الانسحاب، أنشئ طلبًا؛ سنراجعه ونرد عليك عبر البريد الإلكتروني. الشروط:',
  returnPolicyLink: 'شروط الإرجاع والانسحاب',
  returnStart: 'إنشاء طلب إرجاع / انسحاب',
  returnStartExchange: 'إنشاء طلب إرجاع أو انسحاب أو استبدال',
  returnResolution: 'ماذا تريد؟',
  returnResolutions: {
    refund: 'استرداد المبلغ',
    exchange: 'الاستبدال (بخيار آخر من المنتج نفسه)',
  },
  exchangeHint:
    'يتم الاستبدال بخيارات متوفرة في المخزون وبالسعر نفسه، دون أي رسوم إضافية. للحصول على خيار بسعر مختلف، أنشئ طلب إرجاع ثم قدّم طلبًا جديدًا.',
  exchangeItemsLabel: 'المنتجات المراد استبدالها والكمية والخيار المطلوب بدلًا منها',
  exchangeFor: 'الخيار المطلوب بدلًا من {{title}}',
  exchangeChoose: 'اختر خيارًا',
  exchangeItems: 'سيُرسل بدلًا منها: {{items}}',
  exchangeShipped: 'تم شحن منتج الاستبدال. رقم التتبع: {{number}}',
  cancelledQty: 'تعذّر شحن {{count}} قطعة وتم إلغاؤها',
  cancelledItems: 'المنتجات الملغاة',
  chooseProvince: 'اختر المحافظة',
  chooseDistrict: 'اختر المنطقة',
  chooseProvinceFirst: 'اختر المحافظة أولًا',
  returnKind: 'نوع الطلب',
  returnItems: 'المنتجات والكميات المراد إرجاعها',
  returnQuantityFor: 'الكمية المراد إرجاعها من {{title}}',
  returnNote: 'ملاحظة (اختياري)',
  returnSubmit: 'إرسال الطلب',
  returnSent: 'تم استلام طلبك. سنراسلك عبر البريد الإلكتروني بعد مراجعته؛ يرجى انتظار ردنا قبل إرسال المنتج.',
  returnKinds: {
    withdrawal: 'حق الانسحاب (غيّرت رأيي)',
    defective: 'منتج تالف / معيب',
    wrong_item: 'تم إرسال منتج خاطئ',
    other: 'أخرى',
  },
  returnStatuses: {
    requested: 'قيد المراجعة',
    approved: 'تمت الموافقة',
    rejected: 'لم يُقبل',
    completed: 'مكتمل',
    cancelled: 'ملغى',
  },
  bankTransferTitle: 'بيانات التحويل البنكي',
  bankTransferLead:
    'يرجى تحويل مبلغ {{amount}} إلى أحد الحسابات أدناه وكتابة رقم طلبك في الوصف. يُجهَّز طلبك بمجرد وصول الدفعة.',
  bankTransferDeadline: 'إذا لم تصل دفعتك إلى حسابنا بحلول {{deadline}}، فسيُلغى طلبك تلقائيًا.',
  bank: 'البنك',
  accountHolder: 'صاحب الحساب',
  iban: 'IBAN',
  transferDescription: 'الوصف',
  copy: 'نسخ',
  copied: 'تم النسخ',
  payRedirecting: 'جارٍ تحويلك إلى صفحة الدفع الآمنة…',
  payFrameTitle: 'دفع آمن',
  payFrameMissing:
    'تعذّر فتح نموذج الدفع بالبطاقة (ربما انتهت صلاحيته أو فُتح في علامة تبويب أخرى). استعلم عن طلبك لبدء الدفع من جديد.',
  payFrameLead: 'تُدخل بيانات البطاقة في النموذج الآمن لمزوّد خدمة الدفع، ولا يطّلع عليها المتجر أبدًا.',
  payFrameReturn: 'تابع لعرض نتيجة الدفع',
  paymentInitFailed: 'تعذّر فتح صفحة الدفع. تم حفظ طلبك؛ يمكنك المحاولة مرة أخرى.',
  retryPayment: 'إعادة محاولة الدفع',
  paymentResultTitle: 'نتيجة الدفع',
  paymentChecking: 'جارٍ التحقق من دفعتك…',
  paymentSuccess: 'تم استلام الدفعة. جارٍ تجهيز طلبك.',
  paymentAuthorized: 'تم تأكيد طلبك.',
  paymentAuthorizedLead: 'تم حجز مبلغ الطلب {{number}} على بطاقتك، وسيُخصم عند شحن المنتجات.',
  preauthNote:
    'يُحجز المبلغ على بطاقتك الآن ويُخصم عند شحن المنتجات. دفعة واحدة فقط؛ وقد لا يعمل مع بطاقات الخصم المباشر.',
  paymentFailed: 'تعذّر إتمام الدفع.',
  paymentReview: 'دفعتك قيد المراجعة لدى مزوّد خدمة الدفع. ستظهر النتيجة في صفحة طلبك.',
  paymentPendingLong: 'لم تصل نتيجة الدفع بعد. تحقق من صفحة طلبك بعد بضع دقائق.',
  paymentExpired: 'انتهت مهلة الدفع؛ وأُلغي الطلب.',
  orderNotFound:
    'لم يتم العثور على الطلب. افتح الرابط كما هو تمامًا في بريدك الإلكتروني أو سجّل الدخول إلى حسابك.',
  keepOrderLink: 'احتفظ برابط هذه الصفحة: يمكنك تتبع طلبك من خلاله.',
  trackOrder: 'تتبع الطلب',
  paymentLabel: 'الدفع',
  shipmentTitle: 'تتبع الشحنة',
  trackingNumber: 'رقم التتبع: {{number}}',
  trackShipment: 'تتبع الشحنة',
  partialShipmentNote:
    'تم شحن جزء من طلبك. ستُرسل المنتجات المتبقية في طرد منفصل، وسنبلغك عبر البريد الإلكتروني عند شحنه.',
  shipmentItems: 'في هذا الطرد: {{items}}',
  documentsTitle: 'النصوص التي وافقت عليها',
  sellerInfo: 'معلومات البائع',
  mersis: 'MERSIS: {{no}}',
  kep: 'KEP: {{address}}',
  paymentSecureIyzico: 'تتم معالجة المدفوعات بأمان عبر iyzico',
  etbis: 'مسجّل في ETBİS (انقر للتحقق)',
  etbisQr: 'رمز QR لتسجيل ETBİS',
  consent: {
    title: 'تفضيلات ملفات تعريف الارتباط',
    lead: 'نستخدم دائمًا ملفات تعريف الارتباط اللازمة لعمل الموقع. وبإذنك، نستخدم أيضًا ملفات تعريف ارتباط لقياس الزيارات (التحليلات) ولعرض إعلانات تناسب اهتماماتك (التسويق). يمكنك تغيير اختيارك في أي وقت عبر رابط «تفضيلات ملفات تعريف الارتباط» أسفل الصفحة.',
    policyLink: 'سياسة ملفات تعريف الارتباط',
    acceptAll: 'قبول الكل',
    rejectAll: 'رفض',
    preferences: 'التفضيلات',
    save: 'حفظ اختياراتي',
    close: 'إغلاق',
    necessary: 'ملفات تعريف الارتباط الضرورية',
    necessaryLead: 'لسلة التسوق وتسجيل الدخول والأمان وتذكّر هذا الاختيار. لا يمكن إيقافها.',
    alwaysOn: 'مفعّلة دائمًا',
    analytics: 'ملفات تعريف الارتباط التحليلية',
    analyticsLead: 'تساعدنا على قياس كيفية استخدام الموقع.',
    marketing: 'ملفات تعريف الارتباط التسويقية',
    marketingLead: 'لقياس أداء الإعلانات وعرض إعلانات تناسب اهتماماتك.',
    providers: 'الخدمات: {{list}}.',
    providerNames: {
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics',
      googleAds: 'Google Ads',
      meta: 'بكسل Meta (Facebook، Instagram)',
      tiktok: 'بكسل TikTok',
    },
    transferNote:
      'قد يعالج مزوّدو هذه الخدمات البيانات خارج تركيا. لمزيد من التفاصيل، راجع سياسة ملفات تعريف الارتباط وإشعار الخصوصية.',
    error: 'تعذّر حفظ اختيارك. يرجى المحاولة مرة أخرى.',
    footerLink: 'تفضيلات ملفات تعريف الارتباط',
  },
  legalFallbackNote: 'لم تُنشر هذه الوثيقة باللغة العربية بعد؛ تُعرض النسخة التركية.',
  legalTemplatedNote: 'هذا نموذج. أثناء إتمام الطلب يُملأ ببيانات طلبك ويُرسل إلى بريدك الإلكتروني.',
  unitPrice: 'سعر الوحدة: {{price}} / {{unit}}',
  orderShippingMethod: 'الشحن: {{name}}',
  billingAddress: 'عنوان الفاتورة',
  shippingAddress: 'عنوان التسليم',
  cardSummary: '{{brand}} ···· {{last4}}',
  installmentCount: '{{count}} أقساط',
  awaitingTransferNote: 'طلبك بانتظار التحويل البنكي.',
  awaitingCardNote: 'طلبك بانتظار الدفع بالبطاقة.',
  checkoutBlocked: 'لا يمكن تقديم الطلبات حاليًا',
  address: {
    fullName: 'اسم المستلم',
    phone: 'الهاتف',
    line1: 'العنوان',
    district: 'المنطقة',
    city: 'المحافظة',
    postalCode: 'الرمز البريدي (اختياري)',
    companyName: 'اسم الشركة',
    taxOffice: 'مكتب الضرائب',
    taxNumber: 'الرقم الضريبي / TCKN',
    cityAbroad: 'المدينة',
    districtAbroad: 'الولاية / المنطقة (اختياري)',
    abroadNote: 'بلد التسليم: {{country}}. للشحن إلى بلد آخر، غيّر البلد من أعلى الصفحة.',
  },
  dealerFields: {
    legalName: 'الاسم القانوني للشركة',
    tradeName: 'الاسم التجاري (اختياري)',
    taxOffice: 'مكتب الضرائب',
    taxNumber: 'الرقم الضريبي / TCKN',
    phone: 'هاتف العمل',
    city: 'المحافظة',
    district: 'المنطقة (اختياري)',
    address: 'العنوان الكامل',
    businessType: 'نوع النشاط التجاري (مثل عيادة بيطرية)',
    note: 'ملاحظات إضافية (اختياري)',
  },
  leafletSections: {
    description: 'عن المنتج',
    specs: 'المواصفات',
    videos: 'مقاطع الفيديو',
    documents: 'المستندات',
    composition: 'التركيب',
    usage: 'طريقة الاستخدام',
    warnings: 'التحذيرات',
  },
  orderStatuses: {
    draft: 'مسودة',
    awaiting_payment: 'بانتظار الدفع',
    paid: 'مدفوع',
    processing: 'قيد التجهيز',
    shipped: 'تم الشحن',
    delivered: 'تم التسليم',
    completed: 'مكتمل',
    cancelled: 'ملغى',
  },
  sorts: {
    relevance: 'الأكثر صلة',
    newest: 'الأحدث',
    price_asc: 'السعر (من الأقل إلى الأعلى)',
    price_desc: 'السعر (من الأعلى إلى الأقل)',
    name: 'حسب الاسم',
  },
  paymentMethods: {
    card: 'بطاقة ائتمان/خصم',
    paypal: 'PayPal',
    bank_transfer: 'تحويل بنكي',
    cash_on_delivery: 'الدفع عند الاستلام',
    open_account: 'حساب آجل',
    manual: 'تحويل / نقدًا (بالاتفاق مع المتجر)',
    gift_card: 'بطاقة هدية',
    store_credit: 'رصيد المتجر',
    loyalty_points: 'نقاط الولاء',
  },
  paymentMethodHints: {
    card: 'تُدخل بيانات البطاقة في الصفحة الآمنة لمزوّد خدمة الدفع.',
    paypal: 'ادفع بحساب PayPal الخاص بك عبر صفحة PayPal الآمنة.',
    bank_transfer: 'تظهر البيانات المصرفية بعد تقديم الطلب.',
    cash_on_delivery: 'ادفع لمندوب التوصيل عند الاستلام.',
    open_account: 'يُقيَّد المبلغ على حسابك الجاري لدينا بصفتك موزّعًا.',
  },
  paymentStatuses: {
    authorized: 'مفوَّض (محجوز)',
    pending: 'قيد الانتظار',
    requires_action: 'قيد المراجعة',
    captured: 'تم الاستلام',
    failed: 'فشل',
    cancelled: 'ملغى',
    expired: 'منتهي الصلاحية',
  },
  shipmentStatuses: {
    created: 'قيد التجهيز',
    in_transit: 'في الطريق',
    out_for_delivery: 'خرج للتوصيل',
    delivered: 'تم التسليم',
    returned: 'مُرتجع',
    exception: 'مشكلة في التسليم',
    cancelled: 'ملغى',
  },
  carriers: {
    yurtici: 'Yurtiçi Kargo',
    aras: 'Aras Kargo',
    mng: 'MNG Kargo (DHL eCommerce)',
    ptt: 'PTT Kargo',
    surat: 'Sürat Kargo',
    hepsijet: 'HepsiJET',
    kolaygelsin: 'Kolay Gelsin',
    ups: 'UPS',
    other: 'شركة الشحن',
  },
  paymentLink: {
    title: 'الدفع',
    paid: 'تم استلام دفعة هذا الطلب. شكرًا لك.',
    validUntil: 'رابط الدفع هذا صالح حتى {{date}}.',
    recipient: 'المستلم: {{name}} · {{place}}',
    payButton: 'الدفع بالبطاقة',
  },
  legalKinds: {
    kvkk_notice: 'إشعار الخصوصية (KVKK)',
    membership_terms: 'شروط العضوية',
    pre_information: 'نموذج المعلومات المسبقة',
    distance_sales: 'عقد البيع عن بُعد',
    return_policy: 'الإرجاع والانسحاب',
    privacy_policy: 'سياسة الخصوصية',
    cookie_policy: 'سياسة ملفات تعريف الارتباط',
  },
  units: {
    kg: 'كغ',
    l: 'لتر',
    piece: 'قطعة',
  },
  // F7-19: düzenli gönderim
  addressBook: {
    title: 'عناويني',
    lead: 'عناوين التوصيل التي يمكنك اختيارها عند الدفع. يستخدم التوصيل المنتظم عنوان التوصيل الافتراضي.',
    empty: 'ليست لديك عناوين محفوظة.',
    add: 'إضافة عنوان جديد',
    save: 'حفظ العنوان',
    saved: 'تم حفظ العنوان.',
    cancel: 'إلغاء',
    default: 'التوصيل الافتراضي',
    makeDefault: 'تعيين كافتراضي',
    defaultSaved: 'تم تغيير عنوان التوصيل الافتراضي.',
    setDefault: 'اجعله عنوان التوصيل الافتراضي',
    delete: 'حذف',
    deleteFor: 'حذف عنوان {{name}}، {{city}}',
    deleteConfirm: 'حذف هذا العنوان؟ تستمر التوصيلات المنتظمة التي بدأت باستخدام نسختها منه.',
    deleted: 'تم حذف العنوان.',
  },
  subscription: {
    title: 'التوصيل المنتظم',
    discount: 'خصم {{pct}}٪ على كل طلب منتظم',
    terms:
      'يُفتح طلبك الأول فورًا وتنتقل إلى صفحة الدفع. تُفتح الطلبات التالية بالفترة التي تختارها وبالسعر الحالي؛ نرسل رابط الدفع بالبريد الإلكتروني ونعرضه في «حسابي»، ولا تُحفظ بطاقتك. يمكنك التخطي أو التأجيل أو الإلغاء في أي وقت.',
    interval: 'تكرار التوصيل',
    everyWeek: 'كل أسبوع',
    every: 'كل {{n}} أسابيع',
    start: 'بدء التوصيل المنتظم',
    signIn: 'سجّل الدخول للتوصيل المنتظم',
    addAddress: 'أضف عنوان توصيل في «حسابي»',
  },
  subscriptions: {
    title: 'طلباتي المتكررة',
    lead: 'اطّلع على موعد التوصيل التالي؛ تخطَّه أو أجّله أو أوقفه مؤقتًا أو ألغه. تؤكد كل طلب وتدفعه بنفسك عبر رابط الدفع.',
    linkLead: 'التوصيل التالي، التخطي، التأجيل، الإلغاء',
    signIn: 'سجّل الدخول لعرض طلباتك المتكررة.',
    empty: 'ليست لديك طلبات متكررة. يمكنك البدء من مربع «التوصيل المنتظم» في صفحة المنتج.',
    statuses: {
      active: 'نشط',
      paused: 'متوقف مؤقتًا',
      cancelled: 'ملغى',
    },
    reasons: {
      customer: 'بناءً على طلبك',
      unpaid: 'أُوقف مؤقتًا لعدم دفع طلبين متتاليين',
      unavailable: 'لم يعد هذا المنتج يُباع بالتوصيل المنتظم',
      panel: 'ألغاه المتجر',
      payment_unavailable: 'تعذّر إنشاء رابط الدفع؛ يُرجى التواصل مع المتجر',
    },
    summary: 'الكمية: {{quantity}} · {{interval}}',
    next: 'الطلب التالي: {{date}}',
    address: 'التوصيل: {{address}}',
    pending: 'الطلب {{number}} بانتظار الدفع ({{total}}).',
    pay: 'ادفع الآن',
    redirecting: 'جارٍ تحويلك إلى صفحة الدفع…',
    saved: 'تم تحديث تكرار التوصيل.',
    skip: 'تخطّي التالي',
    skipped: 'تم تخطي الطلب التالي.',
    postponeDate: 'التاريخ الجديد',
    postpone: 'تأجيل',
    postponed: 'تم تأجيل الطلب التالي.',
    pause: 'إيقاف مؤقت',
    paused: 'تم إيقاف التوصيل المنتظم مؤقتًا.',
    resume: 'استئناف',
    resumed: 'تم استئناف التوصيل المنتظم.',
    cancel: 'إلغاء',
    cancelled: 'تم إلغاء التوصيل المنتظم.',
    cancelConfirm:
      'إلغاء هذا التوصيل المنتظم؟ لن تُفتح طلبات جديدة. الطلب الذي ينتظر الدفع يُلغى تلقائيًا عند انتهاء صلاحية رابطه.',
  },
};
